/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} Audio_Description_Export_Status_Rendering_BatchInputs */



/**
* | output |
* | --- |
* | "Rendering Event Audio ({start}-{end} of {total})" |
*
* @param {Audio_Description_Export_Status_Rendering_BatchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_rendering_batch = /** @type {((inputs: Audio_Description_Export_Status_Rendering_BatchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Rendering_BatchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rendu audio des événements (${i?.start}-${i?.end} sur ${i?.total})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audio-Wiedergabe beim Ereignis (${i?.start}-${i?.end} von ${i?.total})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Audio dell'evento di rendering (${i?.start}-${i?.end} di ${i?.total})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обработка аудиособытий (${i?.start}-${i?.end} из ${i?.total})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Audio del evento de renderizado (${i?.start}-${i?.end} de ${i?.total})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`渲染事件音频（${i?.start}-${i?.end} 中的 ${i?.total}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベントオーディオのレンダリング (${i?.total} のうち ${i?.start}-${i?.end})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ऑडियो रेंडरिंग (${i?.start}-${i?.end} of ${i?.total})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Renderizando áudio do evento (${i?.start}-${i?.end} de ${i?.total})`)
	return /** @type {LocalizedString} */ (`Rendering Event Audio (${i?.start}-${i?.end} of ${i?.total})`)
});